
function TwoFormsTwoGenresTemplate() {
    return (
        <div>
            Freely transform between your spaceship mode and
            robot mode (As long as you have ground to land on) to switch not only forms but also genres!
            <p>
                (<b>Tip:</b> You'll have to master both forms if you want to beat the boss.)
            </p>
            <ul>
                <li>
                    <b className="textColorBlue">Spaceship Form - Arcade Shmup:</b>
                    <br />Play a fast-paced on-the-rails "shoot-em-up" vertical scrolling shooter in
                    the vein of classic arcade titles such as Galaga or Gradius.
                </li>
                <li>
                    <b className="textColorBlue">Robot Form - Twin-Stick Omnidirectional Shooter:</b>
                    <br />Play a a more methodical off-the-rails shooter akin to
                    arcade classics like Robotron: 2084 that not only packs significant fire-power, it also lets you move in any direction even backtracking the smhup map!
                    <br /> You could even explore indoor dungeons your spaceship would crash in!
                </li>
            </ul>
        </div>
    )
}

export { TwoFormsTwoGenresTemplate };